export const APP_NAME = "DMWA"

export const IDLE_TIME_INCIDENT_NAME = "Idle Time"

export enum TREND {
	NO_CHANGE = "NO_CHANGE",
	NOT_APPLICABLE = "NOT_APPLICABLE",
	UP = 'UP',
	DOWN = 'DOWN'
}

export enum SEVERITY {
	UNKNOWN = "UNKNOWN",
	NOT_SCORABLE = "NOT_SCORABLE",
	CRITICAL = "CRITICAL",
	WARNING = "WARNING",
	GOOD = "GOOD"
}

export enum ACKNOWLEDGEMENT_STATUS {
	ACK_NOT_REQUIRED = "ACK_NOT_REQUIRED",
	NOT_ACKNOWLEDGED = "NOT_ACKNOWLEDGED",
	ACKNOWLEDGED = "ACKNOWLEDGED"
}

export const TOKEN_STORAGE = "token_storage";
export const APP_ID_STORAGE = "app_id_storage";

